/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  highlight: "0 0% 100%",
  lavDeep: "318 82% 60%",
  teamBlue: "200 100% 60%",
  teamRed: "0 85% 60%",
  btnBg: "transparent",
  btnFg: "hsl(var(--foreground))",
  hover: "hsl(var(--foreground) / 0.08)",
  active: "hsl(var(--foreground) / 0.12)",
  disabled: "0.5",
  loading: "0.6",
  edgeIris:
    "conic-gradient(\n    from 180deg,\n    hsl(262 88% 60% / 0),\n    hsl(262 88% 60% / 0.72),\n    hsl(var(--accent-3) / 0.72),\n    hsl(318 82% 60% / 0.7),\n    hsl(262 88% 60% / 0)\n  )",
  segActiveGrad:
    "linear-gradient(\n    90deg,\n    hsl(var(--primary-soft) / 0.85),\n    hsl(var(--accent-1-soft) / 0.85),\n    hsl(var(--accent-2) / 0.8)\n  )",
  segActiveBase: "hsl(var(--card))",
  gradientChromeDivider:
    "linear-gradient(\n    90deg,\n    hsl(var(--glow) / 0.75),\n    hsl(var(--accent-2)),\n    hsl(var(--glow) / 0.75)\n  )",
  gradientBrandmarkHalo:
    "radial-gradient(circle at 50% 50%, hsl(var(--glow) / 0.7), transparent 70%)",
  gradientBrandmarkFill:
    "linear-gradient(180deg, hsl(var(--accent-1)), hsl(var(--accent-2)))",
  gradientNavUnderlineGlow:
    "linear-gradient(\n    90deg,\n    hsl(var(--glow) / 0.6),\n    hsl(var(--accent-2)),\n    hsl(var(--glow) / 0.6)\n  )",
  lgViolet: "var(--ring)",
  lgCyan: "var(--accent-2)",
  lgPink: "var(--lav-deep)",
  lgBlack: "var(--background)",
  visuallyHiddenTop: "-9999px",
  bg: "var(--background)",
  text: "var(--foreground)",
  textOnAccent: "hsl(var(--foreground))",
  controlFs: "var(--font-ui)",
  fontSizeMd: "var(--font-body)",
  fontWeightBold: "800",
  fontLabel: "12px",
  fontUi: "15px",
  fontBody: "19px",
  fontTitle: "24px",
  fontTitleLg: "30px",
  controlHXs: "24px",
  controlHSm: "32px",
  controlHMd: "40px",
  controlHLg: "48px",
  controlHXl: "56px",
  controlH: "var(--control-h-md)",
  shellWidth: "1280px",
  shellMax: "var(--shell-width)",
  shadowInsetContrast: "inset 0 0 0 var(--hairline-w) var(--ring-contrast)",
  shadowInsetHairline:
    "inset 0 0 0 var(--hairline-w) hsl(var(--card-hairline))",
  shadowControlHover:
    "0 var(--spacing-1) var(--spacing-2) hsl(var(--shadow-color) / 0.3)",
  space1: "var(--spacing-1)",
  space2: "var(--spacing-2)",
  space3: "var(--spacing-3)",
  space4: "var(--spacing-4)",
  space5: "var(--spacing-5)",
  space6: "var(--spacing-6)",
  space7: "var(--spacing-7)",
  space8: "var(--spacing-8)",
  space12: "calc(var(--space-8) + var(--space-4))",
  space16: "calc(var(--space-8) * 2)",
  ringSize1: "var(--spacing-0-5)",
  ringSize2: "var(--spacing-1)",
  ringDiameterXs: "var(--space-5)",
  ringDiameterS: "var(--space-6)",
  ringDiameterM: "var(--space-8)",
  ringDiameterL: "calc(var(--space-8) * 3.5)",
  ringStrokeXs: "var(--ring-size-1)",
  ringStrokeS: "var(--ring-size-1)",
  ringStrokeM: "var(--ring-size-2)",
  ringStrokeL: "var(--ring-size-2)",
  ringInset: "calc(var(--space-3) / 2)",
  layoutGutterSm: "var(--spacing-4)",
  layoutGutterMd: "var(--spacing-5)",
  layoutGutterLg: "var(--spacing-6)",
  aaMinContrast: "4.5",
  space9: "calc(var(--space-8) + var(--space-1))",
  space10: "calc(var(--space-8) + var(--space-2))",
  space11: "calc(var(--space-8) + var(--space-3))",
  depthShadowInset: "var(--shadow-depth-inner)",
  layoutQuickActionMin: "calc(var(--spacing-8) * 3)",
  layoutQuickActionTooltipMax: "calc(var(--spacing-8) * 5)",
  spacing0125: "calc(var(--spacing-1) / 8)",
  spacing025: "calc(var(--spacing-1) / 4)",
  spacing05: "calc(var(--spacing-1) / 2)",
  spacing075: "calc(var(--spacing-1) * 0.75)",
  spacing1: "4px",
  spacing2: "8px",
  spacing3: "12px",
  spacing4: "16px",
  spacing5: "24px",
  spacing6: "32px",
  spacing7: "48px",
  spacing8: "64px",
  iconSize: "var(--icon-size-md)",
  iconSizeXs: "14px",
  iconSizeSm: "16px",
  iconSizeMd: "18px",
  iconSizeLg: "24px",
  iconSizeXl: "32px",
  iconSize2xl: "76px",
  iconStroke100: "var(--spacing-0-5)",
  iconStroke150: "calc(var(--spacing-0-5) * 1.25)",
  controlRadius: "var(--radius-xl)",
  pillarWaveStart: "var(--accent-1)",
  pillarWaveEnd: "var(--accent-2)",
  pillarWaveShadow: "var(--accent-1) / 0.35",
  pillarTradingStart: "var(--lav-deep)",
  pillarTradingEnd: "var(--accent-1)",
  pillarTradingShadow: "var(--lav-deep) / 0.35",
  pillarVisionStart: "var(--success)",
  pillarVisionEnd: "var(--accent-2)",
  pillarVisionShadow: "var(--success) / 0.35",
  pillarTempoStart: "var(--ring)",
  pillarTempoEnd: "var(--accent-1)",
  pillarTempoShadow: "var(--ring) / 0.35",
  pillarPositioningStart: "var(--accent-2)",
  pillarPositioningEnd: "var(--primary)",
  pillarPositioningShadow: "var(--accent-2) / 0.35",
  pillarCommsStart: "var(--lav-deep)",
  pillarCommsEnd: "var(--primary)",
  pillarCommsShadow: "var(--primary) / 0.35",
  cardRadius: "var(--radius-xl)",
  blobRadiusSoft: "calc(var(--radius-2xl) + var(--spacing-2))",
  radiusSm: "6px",
  radiusMd: "8px",
  radiusLg: "12px",
  radiusXl: "16px",
  radius2xl: "24px",
  radiusFull: "9999px",
  background: "247 32% 14%",
  foreground: "258 24% 96%",
  card: "249 28% 21%",
  cardForeground: "var(--foreground)",
  panel: "var(--card)",
  border: "253 26% 28%",
  line: "var(--border)",
  input: "249 26% 15%",
  ring: "262 88% 66%",
  themeRing: "hsl(var(--ring))",
  primary: "262 88% 60%",
  primaryForeground: "0 0% 100%",
  primarySoft: "262 88% 20%",
  accent1: "276 88% 59%",
  accent1Foreground: "0 0% 100%",
  accent1Contrast: "276 92% 88%",
  accent1Soft: "276 88% 22%",
  accent1Hover: "hsl(var(--accent-1) / 0.14)",
  accent2: "168 88% 28%",
  accent2Foreground: "0 0% 100%",
  accent3: "318 82% 60%",
  glow: "296 96% 56%",
  ringMuted: "248 22% 24%",
  danger: "0 84% 60%",
  warning: "43 96% 56%",
  warningSoft: "var(--warning) / 0.1",
  warningSoftStrong: "var(--warning) / 0.2",
  muted: "248 22% 19%",
  mutedForeground: "248 18% 74%",
  fgMuted: "var(--muted-foreground)",
  surface: "248 24% 18%",
  surface2: "248 24% 18%",
  surfaceVhs: "210 22% 10%",
  surfaceStreak: "240 16% 16%",
  shadowColor: "263 78% 56%",
  noirBackground: "352 68% 10%",
  noirForeground: "0 0% 94%",
  noirBorder: "352 44% 24%",
  hardstuckBackground: "120 58% 9%",
  hardstuckForeground: "120 60% 72%",
  hardstuckBorder: "120 42% 22%",
  success: "160 72% 48%",
  successSoft: "var(--success) / 0.2",
  successGlow: "160 72% 38% / 0.6",
  toneTop: "38 92% 60%",
  toneJg: "152 52% 44%",
  toneMid: "265 72% 62%",
  toneBot: "195 75% 56%",
  toneSup: "320 72% 60%",
  auroraG: "var(--accent-2)",
  auroraGLight: "150 100% 85%",
  auroraP: "var(--accent-1)",
  auroraPLight: "272 80% 85%",
  iconFg: "250 96% 84%",
  accentOverlay: "hsl(var(--accent-1))",
  ringContrast: "hsl(var(--ring))",
  glowActive: "hsl(var(--glow))",
  neon: "var(--glow)",
  neonSoft: "hsl(var(--neon))",
  focus: "var(--theme-ring)",
  cardHairline:
    "color-mix(in oklab, hsl(var(--border)) 78%, hsl(var(--foreground)) 22%)",
  hairlineW: "1px",
  controlPx: "var(--spacing-3)",
  reviewResultWinGradient:
    "linear-gradient(\n    90deg,\n    hsl(var(--success) / 0.22),\n    hsl(var(--accent-1) / 0.18)\n  )",
  reviewResultLossGradient:
    "linear-gradient(\n    90deg,\n    hsl(var(--danger) / 0.24),\n    hsl(var(--primary) / 0.2)\n  )",
  shadow: "0 12px 34px hsl(258 42% 6% / 0.32)",
  shadowDropdown: "0 12px 40px hsl(var(--shadow-color) / 0.55)",
  shadowNeoSm:
    "calc(var(--spacing-1)) calc(var(--spacing-1)) calc(var(--spacing-2))\n      hsl(var(--panel) / 0.72),\n    calc(var(--spacing-1) * -1) calc(var(--spacing-1) * -1) calc(var(--spacing-2))\n      hsl(var(--foreground) / 0.06)",
  shadowDepthOuter:
    "calc(var(--spacing-3)) calc(var(--spacing-3)) var(--spacing-5)\n      hsl(var(--panel) / 0.72),\n    calc(var(--spacing-3) * -1) calc(var(--spacing-3) * -1) var(--spacing-5)\n      hsl(var(--foreground) / 0.06)",
  shadowDepthOuterStrong:
    "var(--spacing-4) var(--spacing-4) var(--spacing-6) hsl(var(--panel) / 0.72),\n    calc(var(--spacing-4) * -1) calc(var(--spacing-4) * -1) var(--spacing-6)\n      hsl(var(--foreground) / 0.08)",
  shadowDepthInner:
    "inset var(--spacing-1) var(--spacing-1) var(--spacing-3)\n      hsl(var(--panel) / 0.85),\n    inset calc(var(--spacing-1) * -1) calc(var(--spacing-1) * -1) var(--spacing-3)\n      hsl(var(--foreground) / 0.08)",
  shadowRing: "0 0 var(--spacing-3) hsl(var(--ring))",
  shadowDepthSoft:
    "calc(var(--spacing-2)) calc(var(--spacing-2)) var(--spacing-4)\n      hsl(var(--panel) / 0.6),\n    calc(var(--spacing-2) * -1) calc(var(--spacing-2) * -1) var(--spacing-4)\n      hsl(var(--foreground) / 0.07)",
  shadowGlowSm: "0 0 var(--spacing-2) var(--glow-active)",
  shadowGlowMd: "0 0 var(--spacing-4) var(--glow-active)",
  shadowGlowLg: "0 0 var(--spacing-5) var(--glow-active)",
  shadowGlowXl: "0 var(--spacing-2) var(--spacing-6) var(--glow-active)",
  shadowNavActive:
    "0 0 0 var(--hairline-w) hsl(var(--ring) / 0.35),\n    0 var(--spacing-2) var(--spacing-6) hsl(var(--ring) / 0.2)",
  shadowOutlineSubtle: "0 0 0 var(--hairline-w) hsl(var(--border) / 0.12)",
  shadowOutlineFaint: "0 0 0 var(--hairline-w) hsl(var(--border) / 0.08)",
  shadowBadge:
    "inset 0 var(--hairline-w) 0 hsl(var(--foreground) / 0.06),\n    0 0 0 var(--hairline-w) hsl(var(--card-hairline) / 0.35),\n    0 var(--spacing-3) var(--spacing-4) hsl(var(--shadow-color) / 0.18)",
  shadowGlowCurrent: "0 0 var(--spacing-2) currentColor",
  shadowNeonSoft:
    "0 0 var(--spacing-2) var(--neon),\n    0 0 var(--spacing-4) var(--neon-soft)",
  shadowNeonStrong:
    "0 0 var(--spacing-3) var(--neon),\n    0 0 var(--spacing-5) var(--neon-soft)",
  shadowControl:
    "inset 0 var(--spacing-1) var(--spacing-2) 0 color-mix(in oklab, hsl(var(--shadow-color)) 18%, hsl(var(--background)) 82%),\n    var(--shadow-outline-subtle)",
  glowStrong: "var(--ring) / 0.55",
  glowSoft: "var(--accent-1) / 0.25",
  shadowNeon:
    "0 0 calc(var(--space-2)) hsl(var(--neon) / 0.55),\n    0 0 calc(var(--space-4)) hsl(var(--neon-soft) / 0.35),\n    calc(var(--spacing-0-5)) calc(var(--spacing-0-5) * -1) calc(var(--space-3)) hsl(var(--neon) / 0.3),\n    calc(var(--spacing-0-5) * -1.25) calc(var(--spacing-0-5) * 1.25) calc(var(--space-4)) hsl(var(--neon-soft) / 0.24),\n    0 calc(var(--spacing-1)) calc(var(--space-5)) hsl(var(--neon-soft) / 0.18)",
  btnPrimaryHoverShadow:
    "0 calc(var(--space-1) / 2) calc(var(--space-3) / 2)\n    calc(-1 * var(--space-1) / 4) hsl(var(--accent-1) / 0.25)",
  btnPrimaryActiveShadow:
    "inset 0 0 0 calc(var(--space-1) / 4)\n    hsl(var(--accent-1) / 0.6)",
  heroDividerBlur: "calc(var(--spacing-1) * 1.5)",
  heroIllustrationOpacity: "0.84",
  heroIllustrationBlur: "calc(var(--space-4) + var(--space-1))",
  warningForeground: "0 0% 100%",
  successForeground: "0 0% 100%",
  dangerForeground: "0 0% 100%",
  stateSuccessSurface:
    "color-mix(in oklab, hsl(var(--success)) 18%, hsl(var(--surface)))",
  stateSuccessBorder:
    "color-mix(in oklab, hsl(var(--success)) 65%, hsl(var(--border)))",
  stateWarningSurface:
    "color-mix(in oklab, hsl(var(--warning)) 20%, hsl(var(--surface)))",
  stateWarningBorder:
    "color-mix(in oklab, hsl(var(--warning)) 60%, hsl(var(--border)))",
  stateDangerSurface:
    "color-mix(in oklab, hsl(var(--danger)) 18%, hsl(var(--surface)))",
  stateDangerBorder:
    "color-mix(in oklab, hsl(var(--danger)) 62%, hsl(var(--border)))",
  auroraGLightColor: "hsl(var(--aurora-g-light))",
  auroraPLightColor: "hsl(var(--aurora-p-light))",
  elevation0: "none",
  elevation1: "var(--shadow-outline-faint)",
  elevation2: "var(--shadow-outline-subtle)",
  elevation3: "var(--shadow-control)",
  skeletonBg: "hsl(var(--muted) / 0.6)",
  skeletonFill: "hsl(var(--foreground) / 0.08)",
  gradientNoiseOpacity: "0.1",
  gradientNoiseOverlayOpacity: "0.06",
  cardNoiseOpacity: "0.06",
  textureGrainOpacity: "0.04",
  textureScanlineOpacity: "0.06",
  shadowInnerSm:
    "inset 0 var(--spacing-0-125) var(--spacing-0-5) hsl(var(--shadow-color) / 0.18)",
  shadowInnerMd:
    "inset 0 var(--spacing-0-25) var(--spacing-1) hsl(var(--shadow-color) / 0.28)",
  shadowOuterLg:
    "0 var(--spacing-4) var(--spacing-7) hsl(var(--shadow-color) / 0.36)",
  glowPrimary: "hsl(var(--primary) / 0.55)",
  blobSurface1: "hsl(var(--surface))",
  blobSurface2: "hsl(var(--surface-2))",
  blobSurface3: "hsl(var(--card))",
  blobSurfaceShadow: "hsl(var(--shadow-color) / 0.4)",
  glitchNoisePrimary:
    "hsl(var(--accent-1) / var(--texture-grain-opacity, 0.04))",
  glitchNoiseSecondary: "hsl(var(--ring) / var(--texture-grain-opacity, 0.04))",
  glitchNoiseContrast:
    "hsl(var(--foreground) / var(--texture-grain-opacity, 0.04))",
  elevationCard: "var(--shadow-outline-subtle)",
  elevationCardPressed: "var(--shadow-control)",
  neoDepthSm: "var(--spacing-1)",
  neoDepthMd: "var(--spacing-3)",
  neoDepthLg: "var(--spacing-4)",
  neoSurface:
    "color-mix(in oklab, hsl(var(--card)) 88%, hsl(var(--panel)) 12%)",
  neoSurfaceAlt:
    "color-mix(in oklab, hsl(var(--panel)) 82%, hsl(var(--card)) 18%)",
  neoHighlight: "color-mix(in oklab, hsl(var(--ring)) 18%, hsl(var(--card)))",
  depthShadowOuter: "var(--shadow-depth-outer)",
  depthShadowOuterStrong: "var(--shadow-depth-outer-strong)",
  depthShadowSoft: "var(--shadow-depth-soft)",
  depthShadowInner: "var(--shadow-depth-inner)",
  depthGlowHighlightSoft: "hsl(var(--highlight) / 0.08)",
  depthGlowHighlightMedium: "hsl(var(--highlight) / 0.35)",
  depthGlowHighlightStrong: "hsl(var(--highlight) / 0.55)",
  depthGlowShadowSoft: "hsl(var(--shadow-color) / 0.14)",
  depthGlowShadowMedium: "hsl(var(--shadow-color) / 0.28)",
  depthGlowShadowStrong: "hsl(var(--shadow-color) / 0.42)",
  depthFocusRingRest:
    "0 0 0 0 hsl(var(--ring) / 0),\n    0 0 0 0 hsl(var(--ring) / 0)",
  depthFocusRingActive:
    "0 0 0 calc(var(--hairline-w) * 1) hsl(var(--ring))\n    var(--shadow-glow-lg)",
  backdropBlob1: "var(--lg-violet)",
  backdropBlob2: "var(--lg-cyan)",
  backdropBlob3: "var(--lg-pink)",
  backdropBlobShadow: "var(--lg-black)",
  backdropGridPrimary: "var(--accent-1)",
  backdropGridSecondary: "var(--accent-1)",
  backdropGridOpacity: "0.1",
  backdropDrip1: "var(--backdrop-blob-1)",
  backdropDrip2: "var(--backdrop-blob-2)",
  backdropDrip3: "var(--backdrop-blob-3)",
  backdropDripShadow: "var(--backdrop-blob-shadow)",
  neoGlowStrength: "0.45",
  neonOutlineOpacity: "0.35",
  glitchIntensity: "1.0",
  glitchFringe: "12deg",
  glitchStaticOpacity: "0.054",
  glitchNoiseLevel: "var(--glitch-static-opacity)",
  glitchOverlayButtonOpacity: "0.42",
  glitchOverlayButtonOpacityReduced: "0.28",
  glitchChromaticOffsetStrong: "calc(var(--spacing-0-25) / 4)",
  glitchChromaticOffsetMedium: "calc(var(--spacing-0-25) * 3 / 20)",
  glitchChromaticOffsetLight: "calc(var(--spacing-0-25) / 10)",
  glitchHaloOpacity: "0.28",
  glitchRingColor: "hsl(var(--ring) / 0.55)",
  glitchRingBlur: "var(--space-2)",
  glitchRingShadow: "0 0 var(--glitch-ring-blur) var(--glitch-ring-color)",
  glitchAccentColor: "hsl(var(--accent-1) / 0.35)",
  glitchAccentBlur: "var(--spacing-0-5)",
  glitchAccentShadow:
    "0 0 var(--glitch-accent-blur) var(--glitch-accent-color)",
  retroGridStep: "24px",
  retroGridOpacity: "0.15",
  glitchOverlayOpacityCard: "var(--theme-scanline-opacity-moderate, 0.06)",
  shadowInnerLg:
    "inset 0 var(--spacing-0-5) var(--spacing-2) hsl(var(--shadow-color) / 0.36)",
  shadowOuterXl:
    "0 var(--spacing-5) var(--spacing-8) hsl(var(--shadow-color) / 0.45)",
  glowRing:
    "0 0 0 calc(var(--spacing-0-5)) hsl(var(--ring) / 0.5), 0 0 var(--spacing-3) hsl(var(--ring) / 0.22)",
  glitchNoiseHover: "calc(var(--glitch-noise-level) * 1.3)",
  gridColor: "var(--accent-1)",
  gridAlpha: "0.1",
  gridSize: "calc(var(--space-6) - var(--space-1))",
  shadowOuterSm:
    "0 var(--spacing-2) var(--spacing-4) hsl(var(--shadow-color) / 0.24)",
  shadowOuterMd:
    "0 var(--spacing-3) var(--spacing-6) hsl(var(--shadow-color) / 0.3)",
  cardElev1: "var(--shadow-outline-faint), var(--shadow-outer-sm)",
  cardElev2: "var(--shadow-outline-subtle), var(--shadow-outer-md)",
  cardElev3: "var(--shadow-outline-subtle), var(--shadow-outer-lg)",
  glowRingSm: "0 0 0 calc(var(--spacing-0-25)) hsl(var(--ring) / 0.45)",
  glowRingMd:
    "0 0 0 calc(var(--spacing-0-5)) hsl(var(--ring) / 0.5), 0 0 var(--spacing-2) hsl(var(--ring) / 0.2)",
  blobSurface:
    "color-mix(in oklab, hsl(var(--surface)) 70%, hsl(var(--surface-2)) 30%)",
  dripSurface:
    "color-mix(in oklab, hsl(var(--accent-1)) 18%, hsl(var(--background)) 82%)",
  gradientBlobPrimary:
    "radial-gradient(120% 120% at 50% 10%, hsl(var(--surface) / 0.85), hsl(var(--surface-2) / 0.35), transparent 85%)",
  gradientDripOverlay:
    "radial-gradient(60% 40% at 10% 0%, hsl(var(--backdrop-drip-1) / 0.2), transparent 60%), radial-gradient(50% 35% at 100% 5%, hsl(var(--backdrop-drip-2) / 0.18), transparent 60%), radial-gradient(55% 35% at 50% 120%, hsl(var(--backdrop-drip-3) / 0.14), transparent 65%), radial-gradient(120% 100% at 50% 100%, hsl(var(--backdrop-drip-shadow) / 0.35), transparent 70%)",
  gradientDripOverlayCompact:
    "radial-gradient(125% 85% at 18% -20%, hsl(var(--backdrop-drip-1) / 0.28), transparent 65%), radial-gradient(115% 85% at 82% -15%, hsl(var(--backdrop-drip-2) / 0.24), transparent 62%), radial-gradient(120% 95% at 50% 110%, hsl(var(--backdrop-drip-3) / 0.16), transparent 70%)",
  gradientGlitchPrimary:
    "linear-gradient(135deg, hsl(var(--accent-1) / 0.35), hsl(var(--accent-2) / 0.3))",
  gradientGlitchOverlay:
    "linear-gradient(120deg, hsl(var(--accent-1) / 0.12) 0%, transparent 58%, hsl(var(--ring) / 0.16) 100%), var(--card-overlay-scanlines)",
  gradientGlitchRail:
    "linear-gradient(180deg, hsl(var(--primary) / 0.6) 0%, hsl(var(--accent-1) / 0.45) 45%, hsl(var(--ring) / 0.6) 100%)",
  gradientHeroSlotHighlight:
    "radial-gradient(circle at top left, var(--depth-glow-highlight-medium) 0%, transparent 62%)",
  gradientHeroSlotShadow:
    "radial-gradient(circle at bottom right, var(--depth-glow-shadow-medium) 0%, transparent 65%)",
  gradientHeroTopline:
    "linear-gradient(90deg, hsl(var(--accent-1) / 0.28), transparent 55%, hsl(var(--accent-2) / 0.32))",
  gradientHeroActionHalo:
    "radial-gradient(120% 95% at 50% 0%, hsl(var(--accent-1) / 0.24), transparent 65%)",
  gradientPanelTiltStrong:
    "linear-gradient(140deg, hsl(var(--card) / 0.95), hsl(var(--surface-2) / 0.78))",
  gradientPanelTiltBright:
    "linear-gradient(140deg, hsl(var(--card) / 0.98), hsl(var(--surface-2) / 0.82))",
  gradientPanelTiltMuted:
    "linear-gradient(140deg, hsl(var(--card) / 0.94), hsl(var(--surface-2) / 0.72))",
  dangerSurfaceForeground: "var(--danger-foreground)",
  surfaceOverlaySoft: "0.12",
  surfaceOverlayStrong: "0.2",
  glitchCardSurfaceTop: "hsl(var(--card) / 0.78)",
  glitchCardSurfaceBottom: "hsl(var(--panel) / 0.66)",
  surfaceCardSoft:
    "linear-gradient(180deg, hsl(var(--card) / 0.65), hsl(var(--card) / 0.45))",
  surfaceCardStrong:
    "linear-gradient(180deg, hsl(var(--card) / 0.85), hsl(var(--card) / 0.65))",
  surfaceCardStrongHover:
    "linear-gradient(180deg, hsl(var(--card) / 0.95), hsl(var(--card) / 0.75))",
  surfaceCardStrongActive:
    "linear-gradient(180deg, hsl(var(--card) / 0.8), hsl(var(--card) / 0.6))",
  surfaceCardStrongToday:
    "linear-gradient(180deg, hsl(var(--card) / 0.9), hsl(var(--card) / 0.7))",
  surfaceCardStrongEmpty:
    "linear-gradient(180deg, hsl(var(--card) / 0.6), hsl(var(--card) / 0.5))",
  surfaceRailAccent:
    "linear-gradient(180deg, hsl(var(--accent-1)), hsl(var(--primary)))",
  glitchIntensityDefault: "1.0",
  glitchIntensitySubtle: "calc(var(--glitch-intensity-default) * 0.68)",
  glitchIntensityHeroRail: "0.74",
  glitchIntensityBackdropBlob1: "0.18",
  glitchIntensityBackdropBlob2: "0.16",
  glitchIntensityBackdropBlob3: "0.12",
  glitchIntensityBackdropDrip1: "0.23",
  glitchIntensityBackdropDrip2: "0.2",
  glitchIntensityBackdropDrip3: "0.16",
  glitchIntensityBackdropShadow: "0.38",
  glitchPixel: "var(--glitch-noise-level)",
  statGood: "var(--success)",
  statWarn: "var(--warning)",
  statBad: "var(--danger)",
  easeOut: "cubic-bezier(0.16, 1, 0.3, 1)",
  easeMotionGlitch: "cubic-bezier(0.2, 0.8, 0.2, 1)",
  durQuick: "140ms",
  durChill: "220ms",
  durSlow: "420ms",
  cardOverlayScanlines:
    "repeating-linear-gradient(\n    to bottom,\n    hsl(var(--foreground) / var(--texture-scanline-opacity, 0.06)) 0,\n    hsl(var(--foreground) / var(--texture-scanline-opacity, 0.06)) var(--spacing-0-25),\n    transparent var(--spacing-0-5),\n    transparent calc(var(--spacing-0-5) + var(--spacing-0-25))\n  )",
  glitchDuration: "450ms",
  glowPulse: "glow-pulse var(--dur-slow) var(--ease-out) infinite alternate",
  glitchRgbShift:
    "drop-shadow(calc(var(--glitch-chromatic-offset-light) * -1) 0 0 hsl(var(--accent-1) / 0.45)) drop-shadow(var(--glitch-chromatic-offset-light) 0 0 hsl(var(--ring) / 0.45))",
  glitchScanline:
    "glitch-scanline calc(var(--glitch-duration) * 1.2) steps(2, end) infinite",
  scanline: "var(--glitch-scanline)",
  motionDurationSm: "var(--dur-quick)",
  motionDurationMd: "var(--dur-chill)",
  motionDurationLg: "var(--dur-slow)",
  motionEaseGlitch: "var(--ease-motion-glitch)",
  headerStack: "calc(var(--spacing-8) + var(--spacing-4))",
};
